import React, {useEffect} from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Divider from "@material-ui/core/Divider";
import { Typography, Button } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import wallPaper from "../assets/static/images/kea-sports.jpg";
import { BRAND_NAME } from "../shared/consts";
import { sportsIntro, sportingFields, sportsGallery } from "./configs/SportsData";

const useStyles = makeStyles((theme) => ({
  heroContent: {
    padding: theme.spacing(14, 0, 6),
    backgroundImage: `url(${wallPaper})`,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    backgroundBlendMode: 'darken',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  sectionTitle: {
    paddingBottom: '30px',
    fontWeight: 'bolder',
    paddingTop: '64px',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 6px 2px 0 rgba(0,0,0,0.008)',
    border: '1px solid #E2EAF7',
    borderRadius: '16px'
  },
  galleryMedia: {
    paddingTop: '66.6%',
    backgroundSize: 'cover'
  }
}));

export default function Sports() {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <meta name="description"
              content="Sports and sporting fields offered at King Edwards Academy" />
        <title>{BRAND_NAME} - Sports</title>
      </Helmet>
      <CssBaseline />
      <main>
        <div className={classes.heroContent}>
          <Breadcrumb>
            <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
            <BreadcrumbItem active>Sports</BreadcrumbItem>
          </Breadcrumb>
          <Container maxWidth="sm">
            <Typography
              component="h1"
              variant="h4"
              align="center"
              color="textPrimary"
              style={{fontWeight: 'bold'}}
              gutterBottom>
              <span style={{backgroundColor: 'rgb(245, 195, 0)', padding: '0.0em 0.2em 0.0em 0.2em'}}>
                Sports
              </span>
            </Typography>
          </Container>
        </div>
      </main>

      <Container maxWidth="md">
        <Typography
          component="h2"
          variant="h5"
          align="center"
          color="textPrimary"
          className={classes.sectionTitle}
          gutterBottom>
          Sporting Fields We Offer
        </Typography>
        <Typography align="center" style={{color: '#686868', marginBottom: '40px'}}>
          {sportsIntro}
        </Typography>

        <Grid container spacing={4}>
          {sportingFields.map((sport) => (
            <Grid item key={sport.id} xs={12} sm={6} md={4}>
              <Card className={classes.card} elevation={0}>
                <CardContent>
                  <Typography
                    variant="h6"
                    component="h3"
                    align="center"
                    style={{fontWeight: 'bold'}}>
                    {sport.name}
                  </Typography>
                  <Divider variant="middle" style={{marginBottom: '15px', marginTop: '15px'}} />
                  <Typography align="center" style={{color: '#686868'}}>
                    {sport.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {sportsGallery.length > 0 && (
          <React.Fragment>
            <Typography
              component="h2"
              variant="h5"
              align="center"
              color="textPrimary"
              className={classes.sectionTitle}
              gutterBottom>
              Our Students in Action
            </Typography>
            <Grid container spacing={4}>
              {sportsGallery.map((photo) => (
                <Grid item key={photo.id} xs={12} sm={6} md={4}>
                  <Card className={classes.card} elevation={0}>
                    <CardMedia
                      className={classes.galleryMedia}
                      image={photo.image}
                      title={photo.caption}
                    />
                    <CardContent>
                      <Typography align="center" style={{color: '#686868'}}>
                        {photo.caption}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </React.Fragment>
        )}

        <div style={{textAlign: 'center', marginTop: '48px', marginBottom: '64px'}}>
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => history.push('/apply')}>
            Apply Now
          </Button>
        </div>
      </Container>
    </React.Fragment>
  );
}
